import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import axios from "../axios";
import { Container, Dimmer, Loader, Message, Progress, Step } from 'semantic-ui-react'

import Header from "../ui/Header";
import Footer from "../ui/Footer";
import { translate } from "../../addons/Translate";

import VerifyPhonePage from "./VerifyPhonePage";
import PersonalInfoPage from "./PersonalInfoPage";
import ApplicationPage from "./ApplicationPage";
import AttachementPage from "./AttachementPage";

class ApplyPage extends Component {
	state = {
		active: "verifyPhone",
		data: {
			jobId: 0,
			jobDetails: {},
			phone: "",
			code: "",

			first_name: "",
			last_name: "",
			birthday: "",
			birthday_u: "",
			address: "",
			zip_code: "",
			city: "",
			country: "",
			email: "",
		
			job: "",
			job_hours: "",
			qualifications: "",
			available_day: "",
			available_day_u: "",

			expected_salary: "",
			languages_main: [],
			languages_rest: [],
			eu_work_permit: 2,
			work_year_experience: 1,
			comment: "",

			attach_cv: "",
			attach_id: "",
			attach_certificate: "",
			attach_face: ""
		},
		error_msg: "",
		loading: false
	}

	constructor(props) {
		super(props);

		this.state.data.jobId = props.match.params.jobId === undefined ? 0 : props.match.params.jobId;

		if(this.state.data.jobId !== 0) {
			for(var i in window.jobs) {
				if(parseInt(window.jobs[i].id, 10) === parseInt(this.state.data.jobId, 10)) {
					this.state.data.jobDetails = window.jobs[i];
					break;
				}
			}
		}
	}

	onVerifiedPhone(phone, code, country) {
		this.setState({
			active: 'personalInfo',
			data: {
				...this.state.data,
				phone: phone,
				code: code,
				country: country
			}
		})
	}

	onUpdate(data) {
		this.setState({
			data: {
				...this.state.data,
				...data
			}
		}, () => {
			// console.log('onupdate', this.state.data);
		});
	}

	onApplicationUpdate(data) {
		this.setState({
			// active: "email",
			data: {
				...this.state.data,
				...data
			}
		})
	}

	onEmailUpdate(data) {
		this.setState({
			data: {
				...this.state.data,
				...data
			}
		})
	}

	nextStep(step) {
		let newStep = "personalInfo";
		if(step === "personalInfo") {
			newStep = "application";
		} else if(step === "application") {
			newStep = "attachement";
		}

		this.setState({
			active: newStep,
			error_msg: ""
		});
	}

	onSubmit() {
		if(!this.checkCompleted("personalInfo")) {
			this.setState({
				active: "personalInfo",
				error_msg: translate("xxltable.errors.required_fields")
			});

			return Promise.resolve();
		}

		if(!this.checkCompleted("application")) {
			this.setState({
				active: "application",
				error_msg: translate("xxltable.errors.required_fields")
			});

			return Promise.resolve();
		}

		if(!this.checkCompleted("attachement")) {
			this.setState({
				active: "attachement",
				error_msg: translate("xxltable.errors.required_attachement")
			});

			return Promise.resolve();
		}

		this.setState({
			loading: true
		});

		var that = this;

		var config = {
			onUploadProgress: function(progressEvent) {
				that.setState({
					percent: Math.round( (progressEvent.loaded * 100) / progressEvent.total )
				})
			}
		};

		var data = new FormData();

		data.append('mobile', this.state.data.phone.replace("+", ""));
		data.append('code', this.state.data.code);

		data.append('name', this.state.data.first_name);
		data.append('lastname', this.state.data.last_name);
		data.append('birthday', this.state.data.birthday_u);
		data.append('address', this.state.data.address);
		data.append('zip', this.state.data.zip_code);
		data.append('city', this.state.data.city);
		data.append('country', this.state.data.country);
		data.append('email', this.state.data.email);
		data.append('job', this.state.data.job);
		data.append('job_hours', this.state.data.job_hours);
		data.append('qualifications', this.state.data.qualifications);
		data.append('available_day', this.state.data.available_day_u);
		
		data.append('file_cv', this.state.data.attach_cv);
		data.append('file_foto', this.state.data.attach_id);
		data.append('file_certificate', this.state.data.attach_certificate);
		data.append('file_face', this.state.data.attach_face);

		data.append('comment', this.state.data.comment);

		data.append('id_job_advertisement', this.state.data.jobId);
		data.append('languages_main', JSON.stringify(this.state.data.languages_main));
		data.append('languages_rest', JSON.stringify(this.state.data.languages_rest));
		data.append('expected_salary', this.state.data.expected_salary);
		data.append('eu_work_permit', this.state.data.eu_work_permit - 1);
		data.append('work_year_experience', this.state.data.work_year_experience);

		

		return axios.post(window.restaurant.url+window.restaurant.url_submitForm+"?lang="+window.options.lang, data, config)
		.then(res => {
			if(res.data.success === true) {
				this.props.history.push('/thanks');
			} else {
				this.setState({
					loading: false
				});

				return Promise.reject(res.data.message);
			}
		})
		.catch(err => {
			this.setState({
				loading: false
			});

			if(typeof err === "string") {
				return Promise.reject(err);
			}
			
			return Promise.reject(translate("xxltable.errors.server"));
		})
	}

	handleClick = (e, { id }) => this.setState({ active: id })

	checkDisabled(step) {
		if(step === "personalInfo" || step === "application" || step === "attachement") {
			// return false;

			if(this.state.data.phone === "") {
				return true;
			}

			return false;
		}

		if(step === "verifyPhone") {
			if(this.state.data.phone === "") {
				return false;
			}

			return true;
		}
	}

	checkCompleted(step) {
		const { data } = this.state;

		if(step === "personalInfo") {
			if(!data.first_name) return false;
			if(!data.last_name) return false;
			if(!data.birthday) return false;
			if(!data.address) return false;
			if(!data.zip_code) return false;
			if(!data.city) return false;
			if(!data.country) return false;
			if(!data.email) return false;

			return true;
		}

		if(step === "application") {
			if(data.jobId === 0 && !data.job) return false;
			if(!data.job_hours) return false;
			if(!data.qualifications) return false;
			if(!data.available_day) return false;

			return true;
		}

		if(step === "attachement") {
			const { file_cv_option, file_id_option, file_face_option, file_certificate_option } = window.restaurant.settings;

			if(file_cv_option === 1 && !data.attach_cv) return false;
			if(file_id_option === 1 && !data.attach_id) return false;
			if(file_face_option === 1 && !data.attach_face) return false;
			if(file_certificate_option === 1 && data.qualifications > 3 && !data.attach_certificate) return false;

			return true;
		}
	}

	render() {
		const { active, error_msg, data, loading } = this.state;

		return (
			<div id="ApplyPage">
				<Header />

				<Container>
					{
						loading && 
						<Dimmer className="loader-dimmer" active inverted>
							<Loader inverted>{translate('xxltable.step4.sending')} <Progress percent={isNaN(this.state.percent) ? 0 : this.state.percent} indicating /></Loader>
						</Dimmer>
					}

					<Step.Group widths={4}>
						<Step
							id="verifyPhone"
							active={active === 'verifyPhone'}
							icon='phone'
							link
							onClick={this.handleClick}
							title={translate("xxltable.step1.title")}
							description={translate("xxltable.step1.title_desc")}
							disabled={this.checkDisabled("verifyPhone")}
							completed={this.checkDisabled("verifyPhone")}
						/>
						<Step
							id="personalInfo"
							active={active === 'personalInfo'}
							icon='user'
							link
							onClick={this.handleClick}
							title={translate("xxltable.step2.title")}
							description={translate("xxltable.step2.title_desc")}
							disabled={this.checkDisabled("personalInfo")}
							completed={this.checkCompleted("personalInfo")}
						/>
						<Step
							id="application"
							active={active === 'application'}
							icon='file text outline'
							link
							onClick={this.handleClick}
							title={translate("xxltable.step3.title")}
							description={translate("xxltable.step3.title_desc")}
							disabled={this.checkDisabled("application")}
							completed={this.checkCompleted("application")}
						/>
						<Step
							id="attachement"
							active={active === 'attachement'}
							icon='attach'
							link
							onClick={this.handleClick}
							title={translate("xxltable.step4.title")}
							description={translate("xxltable.step4.title_desc")}
							disabled={this.checkDisabled("attachement")}
							completed={this.checkCompleted("attachement")}
						/>
					</Step.Group>

					<div className="in-content">
						{ error_msg !== "" && <Message color='red'>{error_msg}</Message>}

						{ active === "verifyPhone" && <VerifyPhonePage onSubmit={this.onVerifiedPhone.bind(this)} /> }
						{ active === "personalInfo" && <PersonalInfoPage onUpdate={this.onUpdate.bind(this)} onNextStep={this.nextStep.bind(this)} data={data} /> }
						{ active === "application" && <ApplicationPage onUpdate={this.onUpdate.bind(this)} onNextStep={this.nextStep.bind(this)} data={data} /> }
						{ active === "attachement" && <AttachementPage onUpdate={this.onUpdate.bind(this)} onSubmit={this.onSubmit.bind(this)} data={data} /> }
					</div>
				</Container>

				<Footer />
			</div>
		);
	}
}

export default withRouter(ApplyPage);


// WEBPACK FOOTER //
// ./src/components/pages/ApplyPage.js